
import * as React from "react";

import {
    Grid,
    Container,
} from "tabler-react";

import logo from '../assets/areaway_claim.jpg';


import './Content.css';

interface HelloMessageProps {
}

export default class Content extends React.Component<HelloMessageProps, {}>{
    render() {
        return (
            <div className={'content-pane'}>
                <div style={{visibility:'hidden'}}>
                <div className="areaway-header-container-lineup" />
                <Container className="areaway-header-container-logo">
                    <Grid.Row>
                        <Grid.Col width={10} sm={8} md={7}  lg={4}>
                            <div className="areaway-header-container-logo-logo"> 
                            <img src={logo} className="areaway-header-container-logo-logo" alt="AreaWay" />
                            </div>
                        </Grid.Col>
                    </Grid.Row>
                </Container>
                <div className="areaway-header-container-nav">
                    <Container className="areaway-header-container-nav-header clearfix d-none d-sm-block">
                        <div className="nav-item active">Homepage</div>
                        <div className="nav-item">Leistungen</div>
                        <div className="nav-item">Curriculum Vitae</div>
                    </Container>
                </div>
                </div>
                <Container className="my-content">
                {this.props.children}
                </Container>
            </div>
        );
    }
}